@if (
  {
    currentUser: currentUser$ | async,
    userRole: userRoles$ | async
  };
  as STATE
) {
  <article class="user-information">
    <section class="avatar">
      <img [lazyLoad]="'/assets/images/admin.svg'" alt="" />
      <span class="camera">
        <img [src]="'/assets/icons/camera.svg'" alt="" />
      </span>
    </section>
    <section class="user">
      <h3 class="user__role">
        {{ STATE.userRole | userRole }}
      </h3>
    </section>
  </article>
}
